import Blason from "./Blason";
import Wordmark from "./Wordmark";
import { T, UNIVERSES, EMAIL } from "./content";
import { scrollToId } from "./hooks";

const NAV = ["maison", "univers", "galerie", "fondateur", "contact"];

export default function Footer({ lang }) {
  const t = T[lang];
  const go = (id) => (e) => {
    e.preventDefault();
    scrollToId(id);
  };
  return (
    <footer className="footer" data-testid="site-footer">
      <div className="container">
        <div className="footer__top">
          <div className="footer__brand">
            <Blason height={46} />
            <Wordmark width={150} />
            <p className="lead">{t.footerLead}</p>
          </div>
          <div>
            <h5>{t.footerNav}</h5>
            <ul>
              {NAV.map((s) => (
                <li key={s}>
                  <a href={`#${s}`} onClick={go(s)}>
                    {t.nav[s]}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h5>{t.footerContact}</h5>
            <ul>
              <li>
                <a href={`mailto:${EMAIL}`}>{EMAIL}</a>
              </li>
              <li>{t.contactHq}</li>
              {UNIVERSES.slice(0, 3).map((u) => (
                <li key={u.num}>{lang === "fr" ? u.nameFr : u.nameEn}</li>
              ))}
            </ul>
          </div>
        </div>
        <div className="footer__bottom">
          <span>{t.rights}</span>
          <span>LEBOURGEOIS.LU</span>
        </div>
      </div>
    </footer>
  );
}
